const AsSeenOnLogos = () => {
  const logos = [
    { src: "/assets/images/car-competition/logo_thesun.svg", alt: "The Sun" },
    { src: "/assets/images/car-competition/logo_mirror.svg", alt: "The Mirror" },
    { src: "/assets/images/car-competition/logo_dailystar.svg", alt: "Daily Star" },
    { src: "/assets/images/car-competition/logo_express.svg", alt: "Express" },
    { src: "/assets/images/car-competition/logo_dailymail.svg", alt: "Daily Mail" },
    { src: "/assets/images/car-competition/logo_4.svg", alt: "Channel 4" },
    { src: "/assets/images/car-competition/logo_sky.svg", alt: "Sky" },
  ];

  return (
    <div className="flex flex-col items-center gap-3 lg:gap-6 font-jost w-full">
      <div className="self-stretch text-gray-5 text-center text-lg lg:text-2xl font-medium leading-6 lg:leading-[30px] uppercase">
        As seen on
      </div>
      <div className="flex flex-wrap items-center justify-center max-lg:gap-x-8 max-lg:gap-y-2 lg:justify-between lg:w-full lg:flex-nowrap">
        {logos.map((logo, index) => (
          <div key={`Logo-${index}`} className="flex items-center justify-center shrink-0">
            <img className="shrink-0 w-auto h-8 lg:h-[38px]" src={logo.src} width={120} height={48} alt={logo.alt} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsSeenOnLogos;
